<template>
  <div class="dialog_wrapper">
    <a-modal
      v-model="editDownloadImgShow"
      :footer="null"
      :maskClosable="false"
      :closable="false"
      :width="700"
      centered
      destroyOnClose
    >
      <div class="dialog_header">
        <a-button type="link" @click="closeDownloadFn"> <a-icon type="close" /></a-button>
        <span>下载图片</span>
        <div>
          <a-button class="mr20" type="link" @click="downloadOK('img')">水印下载</a-button>
          <a-button type="link" @click="downloadOK('none')">无水印下载</a-button>
        </div>
      </div>
      <div class="img_wrapper">
        <a-checkbox-group v-model="selOssId" @change="selChange">
          <div class="imgInfro">本铺</div>
          <div class="ImgBP">
            <div class="item_img">
              <div class="editimg"></div>
              <ul class="ul_img" v-if="thisShopList && thisShopList.length > 0">
                <li class="li_img" v-for="item in thisShopList" :key="item.uid">
                  <a-checkbox class="img_checkbox" :value="item.uid">
                    <img :src="item.url" :title="item.name" :alt="item.name" />
                  </a-checkbox>
                  <!-- <a-checkbox class="img_checkbox" :value="item.uid" /> -->
                </li>
              </ul>
              <img class="img_nodata" v-else src="@/assets/icons/nodata.svg" alt="no data" title="暂无图片" />
            </div>
          </div>

          <div class="imgInfro">内部环境</div>
          <div class="ImgBP">
            <div class="item_img">
              <div class="editimg"></div>
              <ul class="ul_img" v-if="interiorList && interiorList.length > 0">
                <li class="li_img" v-for="item in interiorList" :key="item.uid">
                  <a-checkbox class="img_checkbox" :value="item.uid">
                    <img :src="item.url" :title="item.name" :alt="item.name" />
                  </a-checkbox>
                </li>
              </ul>
              <img class="img_nodata" v-else src="@/assets/icons/nodata.svg" alt="no data" title="暂无图片" />
            </div>
          </div>

          <div class="imgInfro">平面图</div>
          <div class="ImgBP">
            <div class="item_img">
              <div class="editimg"></div>
              <ul class="ul_img" v-if="planeList && planeList.length > 0">
                <li class="li_img" v-for="item in planeList" :key="item.uid">
                  <a-checkbox class="img_checkbox" :value="item.uid">
                    <img :src="item.url" :title="item.name" :alt="item.name" />
                  </a-checkbox>
                </li>
              </ul>
              <img class="img_nodata" v-else src="@/assets/icons/nodata.svg" alt="no data" title="暂无图片" />
            </div>
          </div>

          <div class="imgInfro">周边图</div>
          <div class="ImgBP">
            <div class="item_img">
              <div class="editimg"></div>
              <ul class="ul_img" v-if="rimList && rimList.length > 0">
                <li class="li_img" v-for="item in rimList" :key="item.uid">
                  <a-checkbox class="img_checkbox" :value="item.uid">
                    <img :src="item.url" :title="item.name" :alt="item.name" />
                  </a-checkbox>
                </li>
              </ul>
              <img class="img_nodata" v-else src="@/assets/icons/nodata.svg" alt="no data" title="暂无图片" />
            </div>
          </div>
        </a-checkbox-group>
      </div>

      <div class="dialog_footer">
        <span
        >已选<span>{{ num }}</span
        >张</span
        >
        <a-button type="link" @click="selAll">全选</a-button>
      </div>
    </a-modal>
  </div>
</template>
<script>
export default {
  name: 'DownloadSkCmp',
  props: {
    fileList: {
      type: Object,
      default: () => ({})
    },
    editDownloadImgShow: {
      type: Boolean,
      default: false
    },
    // 租售类型 字典表类型：rent_sale_type
    rentSaleType: {
      type: String,
      default: '1'
    }
  },
  components: {},
  data () {
    return {
      num: 0,
      selOssId: [],

      img1: '',
      img2: '',
      img3: '',
      img4: '',
      img5: '',

      interiorList: [], // 内部list
      planeList: [], // 平面list
      rimList: [], // 周边List
      thisShopList: [], // 本铺List
      videoList: [], // 视频List

      idArr: [],
      fileInfo: {
        createBy: '',
        createTime: '',
        fileName: '',
        fileSuffix: '',
        originalName: '',
        ossId: undefined,
        service: 'huawei',
        url: ''
      },
      list: []
    }
  },
  mounted () {},
  created () {
    // debugger
    this.initFileList()
  },
  methods: {
    selChange () {
      this.num = this.selOssId.length
    },
    // 下载(水印下载，无水印下载)
    downloadOK (type) {
      // 所有图片
      // console.log(this.list)
      // console.log(this.selOssId.toString())
      if (this.num <= 0) {
        this.$message.warning('请选择需要下载的图片')
        return
      }

      // for (const id of this.selOssId) {
      //   for (const f of this.list) {
      //     if (f.uid === id) {
      //       this.downloadHandle(id, f.name, f.name.split('/')[1], type)
      //     }
      //   }
      // }
      const params = {
        rentSaleType: this.rentSaleType, // 租售类型 字典表类型：rent_sale_type
        watermarkType: type, // 水印类型（text，img，none）
        ossIds: this.selOssId.toString(), // OSS对象ID使用 ,分割
        watermarkText: '' // 水印文字
      }
      this.downloadFile.ossMark(params.watermarkType, params.ossIds, params.watermarkText, params)
    },

    // 关闭弹窗
    closeDownloadFn () {
      this.selOssId = []
      this.$emit('closeModal', false)
    },
    selAll (e) {
      this.num = this.idArr.length
      this.selOssId = this.idArr
    },
    initFileList () {
      console.log(this.fileList, '------------------------this.fileList')
      this.list = []
      const fileList = this.fileList
      if (fileList != null) {
        // 1视频 2本铺 3内部 4平面 5周边
        this.interiorList = this.rebuildPicList(fileList.interiorList, 3) // 内部list
        this.planeList = this.rebuildPicList(fileList.planeList, 4) // 平面list
        this.rimList = this.rebuildPicList(fileList.rimList, 5) // 周边List
        this.thisShopList = this.rebuildPicList(fileList.thisShopList, 2) // 本铺List
        // this.videoList = this.rebuildPicList(fileList.videoList,1);//视频List
      }
    },

    rebuildPicList (list, type) {
      const resList = []
      let fileObj = {}
      const ossIdArr = []
      if (list != null && list.length > 0) {
        for (const item of list) {
          fileObj = {}
          fileObj.uid = item.ossId
          fileObj.name = item.fileName
          fileObj.status = 'done'
          fileObj.url = process.env.VUE_APP_OSS_URL + item.fileName
          resList.push(fileObj)
          ossIdArr.push(fileObj.uid)
          this.idArr.push(fileObj.uid)
          this.list.push(fileObj)
        }
      }

      return resList
    },
    initData () {
      this.img1 = ''
      this.img2 = ''
      this.img3 = ''
      this.img4 = ''
      this.img5 = ''
    },

    ossIdHandle (fileList) {
      const ossIdArr = []
      let ossIds = ''
      if (fileList != null && fileList.length > 0) {
        for (const f of fileList) {
          if (f && typeof f.response !== 'undefined') {
            ossIdArr.push(f.response.data.ossId)
            ossIds = ossIdArr.join(',')
          }
        }
      }
      return ossIds
    }
  }
}
</script>
<style >
/* .ant-checkbox{
      z-index: 99;
      left:135px;
      top:5px;
      box-shadow: -1px 3px 3px #050607;
      -webkit-box-shadow: -1px 3px 3px #050607;
    } */
</style>
<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
  border: none;
}
.dialog_wrapper {
  position: relative;
}
.img_wrapper {
  width: 100%;
  height: 600px;
  overflow: auto;
  margin-bottom: 60px;
}
.dialog_header,
.dialog_footer {
  width: 100%;
  height: 40px;
  line-height: 40px;
  display: flex;
  justify-content: space-between;
}
.dialog_footer {
  width: 96%;
  margin: 0px 2%;
  position: absolute;
  left: 0px;
  bottom: 0px;
  z-index: 10;
  background: #fff;
}
.mr20 {
  margin-right: 20px;
}
.imgInfro {
  width: 100%;
  height: 50px;
  line-height: 50px;
  font-weight: bold;
}
.img_nodata {
  width: 180px;
  height: 122px;
  object-fit: cover;
}
.ul_img {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  .li_img {
    width: 180px;
    height: 122px;
    margin-left: 3.67px;
    margin-bottom: 5px;
    list-style-type: none;
    position: relative;

    .img_checkbox {
      width: 100%;
      height: 122px;
      position: relative;
      img {
        width: 160px;
        height: 122px;
        position: absolute;
        left: 20px;
        top: 0px;
        z-index: 9;
        object-fit: cover;
      }
    }
  }

  .li_img:nth-child(3n + 1) {
    margin-left: 0;
  }
}
</style>
